export const getDateIn2Hours = () => {
  const date = new Date();
  date.setHours(date.getHours() + 2);

  return date.getTime();
};
